<template>

  <div style="padding: 40px 0;">
    <div class="copy">
      <span>就诊日期：{{recordList[currentRecord].date}}</span>
      <span style="margin-left: 10px;">医生：{{recordList[currentRecord].doctorName}}</span>
      <a-popconfirm title="是否确认全部复诊" @confirm="copy" okText="确认" cancelText="取消">
        <a-button v-if="data.status=='Diagnosing'" style="margin:0 0px 10px 10px;display: inline;" type="primary">全部复诊</a-button>
      </a-popconfirm>
    </div>
    <div class="table">
      <table border="1">
        <tbody>
          <!-- 主诉 -->
          <tr>
            <th>*主诉*
            </th>
            <td colspan="2">
              {{inputs.chiefComplaint}}
            </td>
          </tr>
          <tr>
            <th>
              标准症候群
            </th>
            <td colspan="2">

              <div class="list">
                <div v-for="item in syndromeList" class="item">
                  <span style="margin-right: 10px;">{{item.projectName}}</span>
                  <p title="点击编辑" v-for="(item2,index) in item.details" style="display:inline" class="row">
                    <span>{{item2.diagnosisName}}：</span>
                    <span>【{{item2?.diagnosisInfo}}】{{item.details.length!=index+1?"；":""}}</span>
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- 现病史 -->
          <tr>
            <th>现病史</th>
            <td colspan="2">
              {{inputs.presentIllnessHistory}}
            </td>
          </tr>
          <!-- 既往史 -->
          <tr>
            <th>既往史</th>
            <td colspan="2">
              {{inputs.pastHistory}}
            </td>
          </tr>
          <!-- 其他 -->
          <tr>
            <th>其他</th>
            <td colspan="2">
              {{inputs.comment}}
            </td>
          </tr>
          <!-- 脉象 -->
          <tr>
            <th rowspan="4">脉象</th>
            <td>运脉: {{inputs.tcmDiagnose}}</td>
          </tr>
          <tr>
            <td>
              左寸脉：{{inputs.leftCun}}

            </td>
            <td>
              右寸脉：{{inputs.rightCun}}
            </td>
          </tr>
          <tr>
            <td>
              左关脉: {{inputs.leftGuan}}
            </td>
            <td>
              右关脉: {{inputs.rightGuan}}

            </td>
          </tr>
          <tr>
            <td>
              左尺脉：{{inputs.leftChi}}

            </td>
            <td>
              右尺脉：{{inputs.rightChi}}
            </td>
          </tr>
          <!-- 舌象 -->
          <tr>
            <th>舌象</th>
            <td colspan="2">
              {{inputs.tongue}}
            </td>
          </tr>
          <!-- 伏病诊断 -->
          <tr>
            <th>*伏病诊断*</th>
            <td colspan="2" class="bg-light">
              {{inputs.fubingDiagnose}}
            </td>
          </tr>
          <!-- 西医诊断 -->
          <tr>
            <th rowspan="2">*西医诊断 *
            </th>
            <td colspan="2">
              {{inputs.wmDiagnose}}
            </td>
          </tr>

        </tbody>
        <tbody v-for="(item,index) in prescriptionInfoList" :key="index">
          <tr>
            <th rowspan="2" style="text-align: center;" class="thBox">
              处方{{index+1}}
              <a-popconfirm v-if="data.status=='Diagnosing'" title="是否确认复制" @confirm="copyPrescription(item)" okText="确认" cancelText="取消">
                <a-button size="small" class="block" type="primary">复制处方</a-button>
              </a-popconfirm>

            </th>
            <td colspan="2">
              <div class="medicalList">
                <div v-for="item2 in item.items">
                  <p>{{item2.name?item2.name:"？"}}：{{item2.quantity}}</p>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div style="display: flex;">
                <div class="box2">
                  <span>药量：{{item.dosageDays}}</span>
                  <span>用量(次/天)：{{item.timesPerDay}}</span>
                  <span>使用方法：{{item.takingMethod}}</span>
                  <span>描述：{{item.description}}</span>
                </div>
              </div>

            </td>
          </tr>
        </tbody>

      </table>

    </div>
    <div class="btnBox">
      <a-button type="primary" @click="next" :disabled="currentRecord==recordList.length-1">
        {{currentRecord==recordList.length-1?
        "已是最早"
        :"上一次("+recordList[currentRecord+1].date+")"}}</a-button>
      <a-button type="primary" @click="prev" :disabled="currentRecord==0">
        {{currentRecord==0?
        "已是最新":
        "下一次("+recordList[currentRecord-1].date+")"}}</a-button>
      <a-button type="primary" @click="compareCase">关闭对比</a-button>
    </div>
  </div>
</template>

<style scoped>
.btnBox {
  position: absolute;
  display: flex;
  justify-content: center;
  background-color: #fff;
  bottom: 0px;
  padding: 5px 0;
  width: 100%;
}
.btnBox .ant-btn {
  margin: 0 10px;
}
.table {
  position: relative;
  height: 70vh;
  overflow: auto;
  margin: 0 auto;
  transition: 0.5s all;
}

.openHistory .table table {
  width: 100%;
}
textarea {
  resize: none;
}

.table .row {
  display: flex;
  vertical-align: middle;
  align-items: center;
}

table {
  /* width: 75%; */
  margin: 0 auto;
  border-color: #aaa;
  text-align: left;
}

tr {
  height: 40px;
}

tr:hover {
  background-color: #fff8e3;
}

th,
td {
  padding: 5px;
}

th {
  text-align: center;
  width: 175px;
}

.ant-input {
  display: inline-block;
}

.ant-select {
  width: 250px;
}

.block {
  display: block;
  margin: 0 auto 5px;
}
.copy {
  position: absolute;
  top: 0;
  right: 0;
}
.buttonBox {
  position: fixed;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
}
.buttonBox .ant-btn {
  margin: 10px 10px 20px 10px;
}
.popconfirm {
  position: relative;
  display: inline-block;
}
.popconfirm .box {
  position: absolute;
  top: 100%;
  left: 50%;
  background-color: #f1fdff;
  transform: translate(-50%, 7px);
  border: 1px solid #ccc;
  padding: 10px;
  width: 300px;
  z-index: 10;
  box-shadow: 3px 3px 7px #00000052;
  border-radius: 10px;
}
/* popconfirm面的小三角 */
.popconfirm .box::after {
  content: "";
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -100%);
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent #ccc transparent;
}
.popconfirm .box h5 {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 3px;
}
.popconfirm .box .content {
  margin-bottom: 10px;
}
.popconfirm .box .content > * {
  margin-bottom: 5px;
}

.popconfirm .btnBox {
  display: flex;
  justify-content: center;
}

.popconfirm .btnBox .ant-btn {
  margin-left: 10px;
}
.btns .ant-btn {
  margin-right: 5px;
}
.list .item {
  position: relative;
}
.list .item > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 28px;
  position: relative;
  padding: 2px 0px 2px 15px;
  cursor: pointer;
}
.list .item .anticon {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  z-index: 1;
}
.list .item .anticon-close-circle {
  display: none;
  position: absolute;
}
.list .item:hover .anticon-close-circle {
  display: inline;
}
.list .item .anticon-close-circle:hover + div {
  color: red;
}

.list .item > div > * {
  margin: 0;
  margin-right: 10px;
}

.inputsBox {
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 10px;
  margin-right: 10px;
}

.inputsBox span {
  display: inline-block;
  width: 100px;
}
.ant-inputs2 {
  width: 100px;
  text-align: center;
}

.medicalList {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
}
.openHistory .medicalList > div {
  width: 33.333%;
}
.medicalList > div {
  width: 25%;
  margin: 5px 0;
}
.medicalList p {
  display: inline-block;
  width: 110px;
  margin-bottom: 0;
  text-align: right;
}

.medicalList span {
  display: none;
  margin-left: 15px;
}
.medicalList > div:hover span {
  display: inline-block;
}
.ant-input2 {
  width: 200px;
}
.thBox {
  transition: 0.2s all;
}
.box2 span {
  margin-right: 10px;
}
.box2 span:first-child {
  margin-left: 5px;
}
</style>


<script>
import {
  CloseCircleOutlined,
  CheckCircleOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep, } from "lodash-es";
import { RecordDetail, GetReportDetail, GetPrescriptionList } from "/src/api/medicalRecord.js";

export default {
  components: {
    CloseCircleOutlined,
    CheckCircleOutlined,
  },
  name: "病历",
  data() {
    return {
      openHistory: false,
      medicalRecordId: -1,
      currentRecord: 0,
      medicalRecordUuid: "",
      medical: {
        id: undefined,
        count: 0,
      },
      prescriptionInfoList: [
      ],
      reportId: "",
      customerId: -1,
      data: {},
      inputs: {
        chiefComplaint: "",
        comment: "",
        pastHistory: "",
        presentIllnessHistory: "",
        syndrome: "",
        disease: "",
        tongue: "",
        leftCunType: "",
        leftCun: "",
        rightCunType: "",
        rightCun: "",
        leftGuanType: "",
        leftGuan: "",
        rightGuanType: "",
        rightGuan: "",
        leftChiType: "",
        leftChi: "",
        rightChiType: "",
        rightChi: "",
        tongue: "",
        fubingDiagnose: "",
        wmDiagnose: "",
        recipeTwo: "",
        recipeThree: "",
        recipeFour: "",
        recipeFive: "",
        recipeSix: "",
      },
      syndromeList: [],
      diseaseList: [],
      showSyndromePop: false,
      showDiseasePop: false,
      setting: [],
      editSetting: [],
      details: [],
      takingMethodOption: [],
      operations: [],
      pulseOption: [],
      //控制症候群编辑的状态（编辑后不会更改）
      editSyndromeListData: {

      },
      editDiseaseListData: {

      },
      currentEdit: "",
      //用来上传更改后的症候群数据
      editDetails: [],
    };
  },
  props: {
    recordList: {
      type: Array,
      default: []
    },
    data: {
      type: Object,
      default: () => ({})
    },
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {

  },
  methods: {
    async init() {
      await this.getRecordDetail()
      this.uuid = window.location.hash.split("/").pop()
      this.getPrescriptionList()
      console.log("recordList", this.recordList);
    },

    prev() {
      if (this.currentRecord > 0) {
        this.currentRecord--;
        this.init();
      }
    },
    next() {
      if (this.currentRecord < this.recordList.length - 1) {
        this.currentRecord++;
        this.init();
      }
    },
    async getRecordDetail() {
      let uuid = this.recordList[this.currentRecord].uuid
      // let uuid = "567eb000986a4c1d80da47d31457b9a3"
      let res = await RecordDetail({ uuid });
      this.inputs = { ...res.data };
      this.data = { ...res.data };


    },
    async getReportDetail() {
      let medicalRecordId = this.data.id
      this.medicalRecordId = medicalRecordId
      this.medicalRecordUuid = this.data.uuid

      let res = await GetReportDetail({ medicalRecordId })
      //每条加上一个isEdit属性

      this.syndromeList = res.data.items.filter(item => item.category == "症候群")
      this.diseaseList = res.data.items.filter(item => item.category == "疾病")
      this.reportId = res.data.id
    },
    async getPrescriptionList() {
      let res = await GetPrescriptionList({ includeItems: true, medicalRecordUuid: this.data.uuid })
      // console.log("GetPrescriptionList", res.data);
      this.prescriptionInfoList = res.data.map(item => {
        item.isEdit = false
        item.showPrescribeBtn = false
        return item
      })


    },
    copy() {
      this.$emit("copy", this.recordList[this.currentRecord].uuid);
    },
    copyPrescription(item) {
      // alert(item.uuid)
      this.$emit("copyPrescription", item.uuid);
    },
    compareCase() {
      this.$emit("compareCase");
    }

  }
};
</script>


